export class LocalizationConstants
{
    public static getText(key: string):string {
        return "";
    }
    public static keys = {
        app_name:"app_name",
        menu_play:"menu_play",
        menu_settings:"menu_settings",
        menu_records:"menu_records",
        menu_exit:"menu_exit",
        exit_confirm_title:"exit_confirm_title",
        exit_confirm_text:"exit_confirm_text",
        exit_confirm_yes:"exit_confirm_yes",
        exit_confirm_no:"exit_confirm_no",
        config_character:"config_character",
        config_difficulty:"config_difficulty",
        config_hand:"config_hand",
        config_field:"config_field",
        config_start:"config_start",
        settings_title:"settings_title",
        settings_sounds:"settings_sounds",
        settings_music:"settings_music",
        settings_lang:"settings_lang",
        lang_en:"lang_en",
        lang_ru:"lang_ru",
        lang_krl:"lang_krl",
        lang_fi:"lang_fi",
        records_title:"records_title",
        records_easy:"records_easy",
        records_medium:"records_medium",
        records_hard:"records_hard",
        pause_title:"pause_title",
        pause_resume:"pause_resume",
        pause_settings:"pause_settings",
        pause_help:"pause_help",
        pause_menu:"pause_menu",
        exit_menu_title:"exit_menu_title",
        exit_menu_text:"exit_menu_text",
        exit_menu_confirm_title:"exit_menu_confirm_title",
        exit_menu_yes:"exit_menu_yes",
        exit_menu_no:"exit_menu_no",
        final_win:"final_win",
        final_fault:"final_fault",
        final_new_record:"final_new_record",
        final_new_game:"final_new_game",
        final_records:"final_records",
        final_main_menu:"final_main_menu",
        tablo_player:"tablo_player",
        tablo_easy:"tablo_easy",
        tablo_medium:"tablo_medium",
        tablo_hard:"tablo_hard",
        tablo_move_number:"tablo_move_number",
        tablo_round:"tablo_round",
        slide_01_text_01:"slide_01_text_01",
        slide_01_text_02:"slide_01_text_02",
        slide_01_text_03:"slide_01_text_03",
        slide_01_text_04:"slide_01_text_04",
        slide_02_text_01:"slide_02_text_01",
        slide_02_text_02:"slide_02_text_02",
        slide_02_text_03:"slide_02_text_03",
        slide_02_text_04:"slide_02_text_04",
        slide_02_text_05:"slide_02_text_05",
        slide_02_text_06:"slide_02_text_06",
        slide_02_text_07:"slide_02_text_07",
        slide_02_text_08:"slide_02_text_08",
        slide_02_text_09:"slide_02_text_09",
        slide_02_text_10:"slide_02_text_10",
        slide_03_text_01:"slide_03_text_01",
        slide_03_text_02:"slide_03_text_02",
        slide_03_text_03:"slide_03_text_03",
        slide_03_text_04:"slide_03_text_04",
        slide_03_text_05:"slide_03_text_05",
        slide_03_text_06:"slide_03_text_06",
        error_title:"error_title",
        error_connection_text:"error_connection_text",
        tablo_city:"tablo_city",
        tablo_edge:"alert_message_purchase_end_error_settings",
        tablo_line:"tablo_line",
        catch_bat:"catch_bat",
        catch_bat_success:"catch_bat_success",
        catch_bat_fail:"catch_bat_fail",
        creators_text:"creators_text",

    };
    public static get app_name():string { return LocalizationConstants.getText(LocalizationConstants.keys.app_name); }
    public static get menu_play():string { return LocalizationConstants.getText(LocalizationConstants.keys.menu_play); }
    public static get creators_text():string { return LocalizationConstants.getText(LocalizationConstants.keys.creators_text); }
    public static get pause_help():string { return LocalizationConstants.getText(LocalizationConstants.keys.pause_help); }
    public static get exit_menu_text():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_menu_text); }
    public static get exit_menu_confirm_title():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_menu_confirm_title); }
    public static get exit_menu_no():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_menu_no); }
    public static get exit_menu_yes():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_menu_yes); }
    public static get catch_bat():string { return LocalizationConstants.getText(LocalizationConstants.keys.catch_bat); }
    public static get catch_bat_success():string { return LocalizationConstants.getText(LocalizationConstants.keys.catch_bat_success); }
    public static get catch_bat_fail():string { return LocalizationConstants.getText(LocalizationConstants.keys.catch_bat_fail); }
    public static get menu_settings():string { return LocalizationConstants.getText(LocalizationConstants.keys.menu_settings); }
    public static get menu_records():string { return LocalizationConstants.getText(LocalizationConstants.keys.menu_records); }
    public static get menu_exit():string { return LocalizationConstants.getText(LocalizationConstants.keys.menu_exit); }
    public static get exit_confirm_title():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_confirm_title); }
    public static get exit_confirm_text():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_confirm_text); }
    public static get exit_confirm_yes():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_confirm_yes); }
    public static get exit_confirm_no():string { return LocalizationConstants.getText(LocalizationConstants.keys.exit_confirm_no); }
    public static get config_character():string { return LocalizationConstants.getText(LocalizationConstants.keys.config_character); }
    public static get config_difficulty():string { return LocalizationConstants.getText(LocalizationConstants.keys.config_difficulty); }
    public static get config_hand():string { return LocalizationConstants.getText(LocalizationConstants.keys.config_hand); }
    public static get config_field():string { return LocalizationConstants.getText(LocalizationConstants.keys.config_field); }
    public static get config_start():string { return LocalizationConstants.getText(LocalizationConstants.keys.config_start); }
    public static get settings_title():string { return LocalizationConstants.getText(LocalizationConstants.keys.settings_title); }
    public static get settings_sounds():string { return LocalizationConstants.getText(LocalizationConstants.keys.settings_sounds); }
    public static get settings_music():string { return LocalizationConstants.getText(LocalizationConstants.keys.settings_music); }
    public static get settings_lang():string { return LocalizationConstants.getText(LocalizationConstants.keys.settings_lang); }
    public static get lang_en():string { return LocalizationConstants.getText(LocalizationConstants.keys.lang_en); }
    public static get lang_krl():string { return LocalizationConstants.getText(LocalizationConstants.keys.lang_krl); }
    public static get lang_fi():string { return LocalizationConstants.getText(LocalizationConstants.keys.lang_fi); }
    public static get records_title():string { return LocalizationConstants.getText(LocalizationConstants.keys.records_title); }
    public static get records_easy():string { return LocalizationConstants.getText(LocalizationConstants.keys.records_easy); }
    public static get records_medium():string { return LocalizationConstants.getText(LocalizationConstants.keys.records_medium); }
    public static get records_hard():string { return LocalizationConstants.getText(LocalizationConstants.keys.records_hard); }
    public static get tablo_move_number():string { return LocalizationConstants.getText(LocalizationConstants.keys.tablo_move_number); }
    public static get tablo_round():string { return LocalizationConstants.getText(LocalizationConstants.keys.tablo_round); }
    public static get pause_resume():string { return LocalizationConstants.getText(LocalizationConstants.keys.pause_resume); }
    public static get slide_01_text_01():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_01_text_01); }
    public static get slide_01_text_02():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_01_text_02); }
    public static get slide_01_text_03():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_01_text_03); }
    public static get slide_01_text_04():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_01_text_04); }
    public static get slide_02_text_01():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_01); }
    public static get slide_02_text_02():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_02); }
    public static get slide_02_text_03():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_03); }
    public static get slide_02_text_04():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_04); }
    public static get slide_02_text_05():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_05); }
    public static get slide_02_text_06():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_06); }
    public static get slide_02_text_07():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_07); }
    public static get slide_02_text_08():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_08); }
    public static get slide_02_text_09():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_09); }
    public static get slide_02_text_10():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_02_text_10); }
    public static get slide_03_text_01():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_03_text_01); }
    public static get slide_03_text_02():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_03_text_02); }
    public static get slide_03_text_03():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_03_text_03); }
    public static get slide_03_text_04():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_03_text_04); }
    public static get slide_03_text_05():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_03_text_05); }
    public static get slide_03_text_06():string { return LocalizationConstants.getText(LocalizationConstants.keys.slide_03_text_06); }
    public static get error_title():string { return LocalizationConstants.getText(LocalizationConstants.keys.error_title); }
    public static get error_connection_text():string { return LocalizationConstants.getText(LocalizationConstants.keys.error_connection_text); }
    public static get tablo_city():string { return LocalizationConstants.getText(LocalizationConstants.keys.tablo_city); }
    public static get tablo_edge():string { return LocalizationConstants.getText(LocalizationConstants.keys.tablo_edge); }
    public static get tablo_line():string { return LocalizationConstants.getText(LocalizationConstants.keys.tablo_line); }
    public static get final_win():string { return LocalizationConstants.getText(LocalizationConstants.keys.final_win); }
    public static get final_fault():string { return LocalizationConstants.getText(LocalizationConstants.keys.final_fault); }
    public static get final_new_record():string { return LocalizationConstants.getText(LocalizationConstants.keys.final_new_record); }
    public static get final_new_game():string { return LocalizationConstants.getText(LocalizationConstants.keys.final_new_game); }
    public static get final_records():string { return LocalizationConstants.getText(LocalizationConstants.keys.final_records); }
    public static get final_main_menu():string { return LocalizationConstants.getText(LocalizationConstants.keys.final_main_menu); }
}